import React, { useState } from 'react';
import { useContracts } from '../../hooks/useContract';
import { shortenAddress } from '../../utils/wallet';
import MiniLoader from '../common/MiniLoader';

const MatrixLevelDropdown = ({ level, memberIds, packageId, expanded, onToggle }) => {
  const { storage } = useContracts();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const maxAtLevel = 1 << level;
  const filled = memberIds.length;
  const percent = Math.min(100, (filled / maxAtLevel) * 100);
  const complete = filled >= maxAtLevel;

  const handleToggle = async () => {
    if (!expanded && !loaded && memberIds.length > 0) {
      setLoading(true);
      try {
        const users = await Promise.all(memberIds.map((id) => storage.users(id)));
        const detailed = users.map((u, i) => ({
          id: memberIds[i],
          wallet: u[0],
          topPackageId: u[8].toNumber ? u[8].toNumber() : Number(u[8])
        }));
        setMembers(detailed);
        setLoaded(true);
      } catch (_) { /* ignore */ }
      finally { setLoading(false); }
    }
    onToggle();
  };

  return (
    <div className={`level-row ${expanded ? 'expanded' : ''} ${complete ? 'complete' : ''}`}>
      <button className="level-header" onClick={handleToggle} disabled={filled === 0}>
        <div className="level-header-left">
          <div className="level-num">L{level}</div>
          <div>
            <div className="level-title">Level {level}</div>
            <div className="level-sub">{filled} / {maxAtLevel} filled</div>
          </div>
        </div>
        <div className="level-header-right">
          {complete ? (
            <span className="badge badge-success">Complete</span>
          ) : (
            <span className="level-percent">{percent.toFixed(0)}%</span>
          )}
          {filled > 0 && (
            <div className={`level-chevron ${expanded ? 'up' : ''}`}>▾</div>
          )}
        </div>
      </button>

      <div className="level-progress">
        <div className="level-progress-fill" style={{ width: `${percent}%` }}></div>
      </div>

      {expanded && (
        <div className="level-body">
          {loading && (
            <div className="text-center" style={{ padding: 20 }}><MiniLoader /></div>
          )}
          {!loading && members.length === 0 && (
            <div className="text-muted text-center" style={{ padding: 16, fontSize: 13 }}>
              No members
            </div>
          )}
          {!loading && members.length > 0 && (
            <div className="level-members">
              {members.map((m) => (
                <div key={m.id} className="level-member">
                  <div className="level-member-avatar">
                    {String(m.id).charAt(0)}
                  </div>
                  <div className="level-member-info">
                    <div className="level-member-name">
                      User #{m.id}
                    </div>
                    <div className="level-member-meta font-mono">
                      {shortenAddress(m.wallet)}
                    </div>
                  </div>
                  <span className="chip chip-cyan">P{m.topPackageId || 0}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MatrixLevelDropdown;
